// @flow
import { system, type Config, type Transform } from 'styled-system';
import type { Spacing } from '@rover/design-system/style-dictionary/build/es6/theme';
import { createTransformWithDefault, reactNativeSafeTransform } from './transforms';

export type MarginProps = {|
  margin?: Spacing,
  marginTop?: Spacing,
  marginRight?: Spacing,
  marginBottom?: Spacing,
  marginLeft?: Spacing,
  marginX?: Spacing,
  marginY?: Spacing,
|};

const noMarginDefaultingTransform: Transform = createTransformWithDefault('0');

const transform: Transform = (spacing, scale) => {
  const value = noMarginDefaultingTransform(spacing, scale);
  return reactNativeSafeTransform(value);
};

const config: Config<MarginProps> = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform,
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform,
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform,
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform,
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform,
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform,
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform,
  },
};

export default system<MarginProps>(config);



// WEBPACK FOOTER //
// ../react-lib/src/styles/styled-system/margin.js